import { createSelector } from 'reselect';

export const shopsSelector = (state) => state.shops;

export const entriesSelector = createSelector(
  shopsSelector,
  (shops) => shops.entries,
);

export const defaultShopsSelector = createSelector(
  shopsSelector,
  (shops) => shops.defaultShops,
);

export const showOnMapSelector = createSelector(
  shopsSelector,
  (shops) => shops.showOnMap,
);

export const pageSelector = createSelector(
  shopsSelector,
  (shops) => shops.page,
);

export const viewAllShopsSelector = createSelector(
  shopsSelector,
  (shops) => shops.viewAllShops,
);

export const userAddressSelector = createSelector(
  shopsSelector,
  (shops) => shops.userAddress,
);

export const searchQuerySelector = createSelector(
  shopsSelector,
  (shops) => shops.searchQuery,
);

export const shopsGroupedByStateSelector = createSelector(
  shopsSelector,
  (shops) => shops.grouped_by_state,
);

export const statesSelector = createSelector(
  shopsSelector,
  (shops) => shops.states,
);

export const selectedStateSelector = createSelector(
  shopsSelector,
  (shops) => shops.selectedState,
);

export const usaStoresByStateSelector = createSelector(
  shopsSelector,
  (shops) => shops.usa_stores,
);

export const canadaStoresByStateSelector = createSelector(
  shopsSelector,
  (shops) => shops.canada_stores,
);

export const directionModeSelector = createSelector(
  shopsSelector,
  (shops) => shops.directionMode,
);

export const directionToSelector = createSelector(
  shopsSelector,
  (shops) => shops.directionTo,
);

export const selectedTravelModeSelector = createSelector(
  shopsSelector,
  (shops) => shops.selectedTravelMode,
);

export const activeStoreIdSelector = createSelector(
  shopsSelector,
  (shops) => shops.activeStoreId,
);
